import { render } from "./NotPbMajorRelevancy.vue?vue&type=template&id=3b060f7c&scoped=true"
import script from "./NotPbMajorRelevancy.vue?vue&type=script&lang=js"
export * from "./NotPbMajorRelevancy.vue?vue&type=script&lang=js"

import "./NotPbMajorRelevancy.vue?vue&type=style&index=0&id=3b060f7c&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b060f7c"]])

export default __exports__